import { SlidersHorizontal, X } from "lucide-react";

const STATUS_OPTIONS = ["Draft", "Submitted", "Pending Approval", "Approved", "Open", "In progress", "Client Review", "Filled"];

function Chip({ label, name, options, testId, value, onChange }) {
  return (
    <label className={`filter-chip ${value ? "filter-chip-active" : ""}`} data-testid={`${testId}-chip`}>
      <span className="filter-chip-label">{label}</span>
      <select data-testid={testId} name={name} value={value} onChange={onChange}>
        <option value="">All</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export const BoardFilterChips = ({ filters, meta, onChange, onClear }) => {
  const activeCount = Object.values(filters).filter(Boolean).length;
  const asOptions = (items) => items.map((item) => ({ value: item, label: item }));
  return (
    <section className="board-filter-bar" data-testid="staffing-board-filters">
      <span className="filter-bar-title"><SlidersHorizontal size={14} /> Filters</span>
      <Chip label="Client" name="client_id" testId="board-client-filter" value={filters.client_id} onChange={onChange} options={meta.clients.map((client) => ({ value: client.id, label: client.name }))} />
      <Chip label="Role" name="role" testId="board-role-filter" value={filters.role} onChange={onChange} options={asOptions(meta.roles)} />
      <Chip label="Priority" name="priority" testId="board-priority-filter" value={filters.priority} onChange={onChange} options={asOptions(["Urgent", "High", "Standard"])} />
      <Chip label="Status" name="status" testId="board-status-filter" value={filters.status} onChange={onChange} options={asOptions(STATUS_OPTIONS)} />
      <Chip label="Recruiter" name="recruiter_id" testId="board-recruiter-filter" value={filters.recruiter_id} onChange={onChange} options={meta.recruiters.map((recruiter) => ({ value: recruiter.id, label: recruiter.name }))} />
      <Chip label="Region" name="region" testId="board-region-filter" value={filters.region} onChange={onChange} options={asOptions(meta.regions)} />
      {activeCount > 0 && (
        <span className="filter-active-group">
          <span className="filter-active-count" data-testid="active-filter-count">{activeCount} active</span>
          <button className="filter-clear-button" data-testid="board-clear-filters" type="button" onClick={onClear}>
            <X size={13} /> Clear
          </button>
        </span>
      )}
    </section>
  );
};
